




























import {Component, Mixins, Prop, Watch} from 'vue-property-decorator'
import Translation from '@/mixins/Translation'
import {Input} from 'element-ui'
import toCurrency from '@/filters/to-currency'

@Component({
  components: {[Input.name]: Input}
})
export default class AmountInput extends Mixins(Translation) {
  @Prop({default: '', type: [Number, String]}) value: number | string
  @Prop({default: 'terms', type: String}) translation: string
  @Prop({default: '원', type: String}) suffixText: string
  @Prop({default: '', type: String}) prefixText: string
  @Prop({default: 'left', type: String}) textAlign: 'left' | 'right' | 'center'
  @Prop({default: true, type: Boolean}) allowDecimal: boolean
  @Prop({default: false, type: Boolean}) readonly: boolean

  inputValue: number | string = ''
  typing: boolean = false
  notNumberOrDotOrDashPath: RegExp = /[^\d|.|-]/g
  notNumberOrDashPath: RegExp = /[^\d|-]/g

  get classes(): string[] {
    return [`is-${this.textAlign}`]
  }

  @Watch('value', {immediate: true})
  __value(value) {
    if(this.typing) {
      return
    }
    this.inputValue = this.setFormat(String(value))
  }

  setFormat(value): string {
    const initialValue = this.unFormat(value)
    return [`${this.prefixText}`, `${toCurrency(Number(initialValue))}`, `${this.suffixText}`].filter((item) => item).join(' ')
  }

  unFormat(value): number | string {
    if(!value) {
      return ''
    }
    const valueArrByDot = String(value).split('.')
    const [essence, decimalValue] = valueArrByDot
    let validValue = essence
    if(valueArrByDot.length > 1 && decimalValue !== '' && this.allowDecimal) {
      validValue = `${essence}.${decimalValue}`
    }
    const path = this.allowDecimal ? this.notNumberOrDotOrDashPath : this.notNumberOrDashPath
    return Number(validValue.replace(path, '')) || ''
  }

  onHandleFocus() {
    if(this.readonly) return
    this.inputValue = this.unFormat(this.inputValue)
    this.typing = true
  }

  onHandleBlur(e) {
    if(this.readonly) return
    this.inputValue = this.setFormat(this.inputValue)
    this.$emit('blur', e)
    this.typing = false
  }

  valueChanged(e) {
    if(this.readonly) return
    this.inputValue = this.unFormat(this.inputValue)
    this.$emit('input', Number(this.unFormat(this.inputValue)))
  }
}
